import './radio-filter.css';
import { h } from 'preact';

import RadioChoice from './components/RadioChoice/RadioChoice';
import RadioChoiceSelected from './components/RadioChoiceSelected/RadioChoiceSelected';

export default function RadioFilter({ id, label, name, value, choices, getMatchCount, onChangeHandler, onResetHandler }) {
	function getTextFromValueChoice(value) {
		const foundChoices = choices.filter(choice => choice.value === value);
		return foundChoices.length === 1 ? foundChoices[0].text : '';
	}

	return (
		<div class={'filter-container radio-filter-container filter-container-' + name.replace(/\s/g, '-').toLowerCase()}>
			<fieldset class="filter-fieldset-container radio-filter-filter-container">
				<legend class="filter-label">{label}</legend>
				{value !== null ?
					<RadioChoiceSelected name={name} text={getTextFromValueChoice(value)} onResetHandler={onResetHandler} /> :
					choices.length > 0 ?
						<ul class="filter-choices-container">
							{choices.map(choice => (
								<RadioChoice
									id={`${id}-${choice.value}`}
									name={name}
									text={choice.text}
									value={choice.value}
									isChecked={choice.value === value}
									onChangeHandler={onChangeHandler}
									matchCount={getMatchCount(name, choice.value)}
								/>
							))}
						</ul>
						: ''}
			</fieldset>
		</div>
	);
}
